import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import { withStyles } from '@material-ui/core/styles';

import { Tooltip } from 'components/admin/Help';
import Info, { Item, Metric } from '../../Info';
import { selectInvoiceMetrics } from '../../../store/selectors/metrics';

const styles = theme => ({
  root: {
    minWidth: '250px',
  },
  section: {
    marginTop: theme.spacing.unit*2,
    marginBottom: theme.spacing.unit*2,
    display: 'flex',
    flexDirection: 'column',
  },
  heading: {
    marginTop: theme.spacing.unit*2,
    marginBottom: theme.spacing.unit*2,
    textAlign: 'center',
  },
});

const InvoiceCardsSide = ({ classes, metrics, showHelp }) => {
  return(
    <Tooltip type="invoice-cards-side" placement="left-end">
      <div>
        <Info title="Invoice KPIs">
          {metrics.map((metric, i) => {
            return (
              <Item key={i}>
                <Metric
                  type={metric.type}
                  label={metric.label}
                  value={metric.display} />
              </Item>
            );
          })}
        </Info>
      </div>
    </Tooltip>
  );
};

// const InvoiceCardsSide = ({ classes, metrics, showHelp }) => {
//   return(
//     <Tooltip
//       open={showHelp}
//       content={<TooltipContent />}
//       placement="left-end"
//     >
//       <Info title="Invoice KPIs">
//         {metrics.map((metric, i) => {
//           return (
//             <Item key={i}>
//               <Metric
//                 type={metric.type}
//                 label={metric.label}
//                 value={metric.display} />
//             </Item>
//           );
//         })}
//       </Info>
//     </Tooltip>
//   );
// };

const mapStateToProps = (state) => ({
  metrics: selectInvoiceMetrics(state),
  showHelp: state.help.showHelp,
});


export default compose(
  withStyles(styles),
  connect(mapStateToProps)
)(InvoiceCardsSide);



// WEBPACK FOOTER //
// ./src/components/admin/Invoices/InvoiceCardsSide.jsx